import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import ImageBrowse from '../../../../Common/Image/ImageBrowse';
import { _showToast } from '../../../../../toastHelper';
import { IconX } from '@tabler/icons-react'

const CommunityAdd = forwardRef(function CommunityAdd(props, ref) {

    const [name, setName] = useState("");
      const [date, setDate] = useState("");
      const [address, setAddress] = useState("");
    const [isOpen, setIsOpen] = useState("");
    const [imageKey, setImageKey] = useState(null);
    const [errors, setErrors] = useState({});
    const imageRef = useRef();
  
    useEffect(() => {
      if (props.data) {
        setName(props.data.name);
        setIsOpen(props.data.show);
        setImageKey(props.data.imageKey);
  
        imageRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
        imageRef?.current?.setFileContent(props.data.imageFile);
      }
    }, [props.data])
  
    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);
  
  
    const validate = () => {
      const errors = {};
  
      if (!name || (name && name.trim() == "")) {
        errors.name = "Name is required";
      }
  
      setErrors(errors);
      return Object.keys(errors).length === 0;
    }
  
    const getData = () => {
      return {
        name: name,
        address: address,
        
      };
  
    };
  
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));
  
    return (
      <div className="card accordion-item ">
        <h2 className="accordion-header">
          <button type="button"
            onClick={() => props.showHidePople(props.index)}
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}>
            {name}
          </button>
        </h2>
  
     
  
         <form>
            <div className="row g-3">
              <div className="col-sm-12">
                <label className="form-label" htmlFor="section2Name">
                Event Title
                </label>
                <input
                  type="text"
                  id="section2Name"
                  name="section2Name"
                  placeholder="Please enter the main title here"
                  className={`form-control ${errors.name ? "is-invalid" : ""
                    }`}
                  value={name}
                
                />
               
              </div>
            
  
              
            
              <div className="col-sm-12">
                <label className="form-label" htmlFor="section2TagLine">
                Description
                </label>
                <textarea
                  name="section2TagLine"
                  id="section2TagLine"
                  className="form-control"
                  placeholder="Please enter the sub heading description here"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  style={{ height: "200px", resize: "none" }}
                />
              </div>
            </div>
          </form>
      </div>
    )
  });

export default CommunityAdd